module.exports = __webpack_public_path__ + "static/media/mahou.c2a47586.png";